import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import { useRoutes } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { Toaster } from 'react-hot-toast'

const SavedRecipes = lazy(() => import('@/pages/SavedRecipes'))

export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  {
    path: '/recipes',
    element: (
      <Suspense fallback={
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="animate-spin w-8 h-8 border-4 border-emerald-600 border-t-transparent rounded-full" />
        </div>
      }>
        <SavedRecipes />
      </Suspense>
    ),
  },
]

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: '12px',
            background: '#1f2937',
            color: '#fff',
            fontSize: '14px',
          },
        }}
      />
      {useRoutes(routes)}
    </>
  )
}

export default App
